import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';
import { push } from 'react-router-redux';

/**
 * Constants
 */
export const REQUEST = '@app/companysaga/REQUEST';
export const SUCCESS = '@app/companysaga/SUCCESS';
export const FAILURE = '@app/companysaga/FAILURE';
export const CLEAR = '@app/companysaga/CLEAR';
export const ADD_DEPARTMENT = '@app/companysaga/ADD_DEPARTMENT';
export const CHANGE_BMK = '@app/companysaga/CHANGE_BMK';
export const UPDATE_TEAM_MEMEBER = '@app/companysaga/UPDATE_TEAM_MEMEBER';

/**
 * Initial state
 */
const initState = {
    data: null,
    loading: false,
    lastFetchTime: null
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                const now = new Date();
                draft.loading = true;
                draft.lastFetchTime = now.toISOString();
                break;
            case SUCCESS:
                draft.data = payload.data;
                draft.loading = false;
                break;
            case FAILURE:
                draft.errorStatus = payload;
                draft.loading = false;
                draft.lastFetchTime = null;
                break;
            case CLEAR:
                draft.data = null;
                draft.lastFetchTime = null;
                break;
            case ADD_DEPARTMENT:
                draft.data.departments.push(payload.data);
                break;
            case CHANGE_BMK:
                draft.data.admin = payload;
                break;
            case UPDATE_TEAM_MEMEBER:
                draft.data.team = draft.data.team.map((el) =>
                    el.user.id === payload.user.id ? payload : el
                );
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR),
    addDepartment: (data) => creator(ADD_DEPARTMENT, data),
    changeBMK: (data) => creator(CHANGE_BMK, data),
    updateTeamMemeber: (data) => creator(UPDATE_TEAM_MEMEBER, data)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        put(actions.clear());
        try {
            const response = yield axios.get(`/companies/show/${payload}`);
            yield put(actions.success(response.data));
        } catch (e) {
            console.error(e);
            const isUnauthorized = e?.response?.status === 403;
            if (isUnauthorized) {
                yield put(push('/error/404'));
            }
            const error = errorMessageGenerator(e);
            yield put(creator(CLEAR));
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
